import React from "react";
import { RpiTableColumn } from "../RpiTable";
import { Skeleton } from "@mantine/core";
import { useRpiTableStyles } from "../RpiTableStyles";
import { RpiTableHead } from "../RpiTableHead";
import { RpiTableBody } from "../RpiTableBody";

export interface RpiTableLoadingStateProps {
  columns: RpiTableColumn<any>[];
  rowCount?: number;
}

export const RpiTableLoadingState: React.FC<RpiTableLoadingStateProps> = ({ columns, rowCount = 20 }) => {
  const skeletonData = Array.from({ length: rowCount }, () => ({}));

  const skeletonColumns: RpiTableColumn<any>[] = columns.map((col) => ({
    ...col,
    accessor: undefined,
    align: undefined,
    noPadding: undefined,
    cell: () => <Skeleton height={20} />,
  }));

  const { classes } = useRpiTableStyles();

  return (
    <table className={classes.table} aria-busy="true" aria-live="polite">
      <caption
        style={{
          position: "absolute",
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: "hidden",
          clip: "rect(0,0,0,0)",
          whiteSpace: "nowrap",
          border: 0,
        }}
      >
        Loading...
      </caption>
      <RpiTableHead columns={columns} />
      <RpiTableBody columns={skeletonColumns} data={skeletonData} />
    </table>
  );
};
